import React from 'react';
import {useRef, useEffect, useState} from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignal, faComputer, faRotate, faSatelliteDish, faHourglassHalf, faVideo } from '@fortawesome/free-solid-svg-icons';
import ReactDOMServer from "react-dom/server";
// import './deviceCard.css';

function DeviceCard(props) {
    const url = `https://${props.devicedatar.domainName}:${props.devicedatar.portRemote}?apikey=${props.devicedatar.apiKey}`;

    const [data, setData] = useState("");
    const [deviceMode, setDeviceMode] = useState("Idle");
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        let intervalId = null;
    
        const getCookie = (name) => {
            const match = document.cookie
              .split("; ")
              .find((row) => row.startsWith(name + "="));
            return match ? decodeURIComponent(match.split("=")[1]) : null;
        };
    
        const ping = async () => {
            try {
                if (props.devicedatar.deviceType === "computer") {
                    const status = await axios.get(`https://${props.devicedatar.domainName}:${props.devicedatar.port}/api/status`, { timeout: 5000 });
                    
                    setData((prev) => status.data.connection.toLowerCase() === "online" ? "Online" : "Offline");
    
                    if (status.data.connection.toLowerCase() === "online") {
                        const loginToken = getCookie("data");
                        setTimeout(async () => {
                            const updateLastOnline = await axios.post(
                                `${import.meta.env.VITE_DEVBACKENDPATH}/api/devicedata/updatelastonline`, 
                                { loginToken, deviceId: props.devicedatar.deviceId, password: props.devicedatar.password }
                            );
                            console.log(updateLastOnline);
                        }, 5000);
                    }
                } else if (props.devicedatar.deviceType === "IoT") {
                    const response = await axios.get(`https://${props.devicedatar.domainName}:${props.devicedatar.port}/api/statusultra`, {
                        headers: { apiKey: props.devicedatar.apiKey },
                        timeout: 5000 
                    });
    
                    setData((prev) => (response.status === 200 ? "Online" : "Offline"));
    
                    if (response.status === 200) {
                        const deviceStatus = response.data;
                        // const isEnabled = deviceStatus.sensor.isEnabled ? "Scanning" : "Idle";
                        // setDeviceMode(isEnabled);
                        if(deviceStatus.sensor.mode === 'live-camera') { 
                            setDeviceMode('Live');
                            // document.getElementById('device-status').innerHTML = ReactDOMServer.renderToString(<>Live<FontAwesomeIcon className='status-icon' icon={faVideo} style={{color: "red"}} /></>);
                        }
                        else if(deviceStatus.sensor.mode === 'recording') { 
                            setDeviceMode('recording'); 
                            // document.getElementById('device-status').innerHTML = ReactDOMServer.renderToString(<>Recording<FontAwesomeIcon className='status-icon' icon={faVideo} style={{color: "red"}} /></>);
                        }
                        else {
                            if(deviceStatus.sensor.isEnabled) {
                                setDeviceMode("Scanning");
                                // document.getElementById('device-status').innerHTML = ReactDOMServer.renderToString(<><FontAwesomeIcon className='status-icon rotate-icon' icon={faRotate} style={{color: "green"}} /></>);
                            } else {
                                setDeviceMode("Idle");
                                // document.getElementById('device-status').innerHTML = ReactDOMServer.renderToString(<><FontAwesomeIcon className='status-icon' icon={faHourglassHalf} style={{color: "orange"}} /></>);
                            }
                        }
    
                        const loginToken = getCookie("data");
                        setTimeout(async () => {
                            const updateLastOnline = await axios.post(
                                `${import.meta.env.VITE_DEVBACKENDPATH}/api/devicedata/updatelastonline`,
                                { loginToken, deviceId: props.devicedatar.deviceId, password: props.devicedatar.password }
                            );
                            console.log(updateLastOnline);
                        }, 5000);
                    }
                }
            } catch (error) {
                console.error("Ping error:", error);
                setData("Offline");
            }
        };
    
        ping(); // Run once immediately
    
        intervalId = setInterval(() => {
            setTime(new Date()); // Update time
            ping(); // Update status
        }, 60000);
    
        return () => clearInterval(intervalId); // Cleanup interval on unmount
    }, [props.devicedatar]); // Dependency ensures useEffect re-runs if props change    
    
    // If device is computer
    if(props.devicedatar.deviceType === "computer") {
        return(
            <article className="card">
                <section className="flex column justify-content-start align-items-start">
                    <div className='flex row space-between width-100p'>
                        <h3 className="h3">{props.devicedatar.hostname}</h3>
                        <FontAwesomeIcon icon={faComputer} className='h3' size='xl' />
                    </div>
                    {/* <h6 className="card-subtitle mb-2 text-muted">{props.devicedatar.remoteAddress}</h6> */}
                    <p className='color-muted'><b>Status:</b> {data === "Online" ? <FontAwesomeIcon icon={faSignal} style={{color: "#2ad71d"}} /> : <FontAwesomeIcon icon={faSignal} style={{color: "red"}} />}</p>
                    {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                    <p className='color-muted'><b>Last Online:</b> {data === "Online" ? new Date(Date.now()).toLocaleString() : props.devicedatar.lastOnline}</p>
                    <a href={`/dashboard/rdp/${props.devicedatar.deviceId}`} className="text-decoration-none color-primary-2">Remote Control</a>
                    {/* <a href={`/dashboard/controlpanel/${props.devicedatar.deviceId}`} className="">Control Panel</a> */}
                </section>
            </article>
        );
    // else Device is IoT
    } else {
        return(
            <article className="card">
                <section className="flex column justify-content-start align-items-start">
                    <div className='flex row space-between width-100p'>
                        <h3 className="h3">{props.devicedatar.hostname}</h3>
                        <FontAwesomeIcon icon={faSatelliteDish} className='h3' size='xl' />
                    </div>
                    {/* <h6 className="card-subtitle mb-2 text-muted">{props.devicedatar.remoteAddress}</h6> */}
                    <p id='device-status' className='color-muted'><b>Status: </b> 
                        { data === "Online" ? (deviceMode !== "Live" ? (deviceMode === "Scanning" ? <><FontAwesomeIcon className='status-icon rotate-icon' icon={faRotate} style={{color: "green"}} /></> : <><FontAwesomeIcon className='status-icon' icon={faHourglassHalf} style={{color: "orange"}} /></>) : <><FontAwesomeIcon className='status-icon' icon={faVideo} style={{color: "red"}} /></>) : <FontAwesomeIcon icon={faSignal} style={{color: "red"}} />}
                    </p>
                    {/* <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> */}
                    <p className='color-muted'><b>Last Online:</b> {new Date(props.devicedatar.lastOnline).toLocaleString()}</p>
                    <a href={`/dashboard/controlpanel/${props.devicedatar.deviceId}`} className="text-decoration-none color-primary-2">Control Panel</a>
                </section>
            </article>
        );
    }
}

export default DeviceCard;